define(["require", "exports", "jquery", "knockout", "log", "../../utils/urls", "../../utils/tools", "../../utils/kendoUtils", "../../utils/dateUtils", "./logoutActions", "../../models/UserContext"], function (require, exports, $, ko, log, urls_1, tools, KendoUtils, DateUtils, LogoutActions, UserContext) {
    "use strict";
    var CallDetailsReport = /** @class */ (function () {
        function CallDetailsReport() {
            this.filterCdrSummaryReportByStartDate = ko.observable(DateUtils.today());
            this.filterCdrSummaryReportByEndDate = ko.observable(DateUtils.today());
            this.dateRangeText = ko.observable("Today");
            this.selectRangeTimeout = 0;
            this.filterCdrByDomain = ko.observable("");
            this.filterCdrByFromPhoneNumber = ko.observable("");
            this.filterCdrByToPhoneNumber = ko.observable("");
            this.filterApplied = ko.observable(false);
            this.filterInProgress = ko.observable(false);
            this.canExport = ko.observable(UserContext.hasAccess("Admin,BasicReports.Export"));
            this.isAdmin = ko.observable(UserContext.hasAccess("Admin,Reports.Admin"));
            this.defaultDomain = "izzy.telego.com";
            this.logout = new LogoutActions();
        }
        CallDetailsReport.prototype.init = function () {
            var self = this;
            $("#page-title").text("Call Details Report");
            tools.ajaxGet({
                url: "/Reports/GetCallDetailsLookupData",
                success: function (data) {
                    if (data.Success) {
                        self.reportLookupLists = data.Data.lookupLists;
                        self.defaultDomain = data.Data.lookupLists.DefaultDomain;
                        self.filterCdrByDomain(self.defaultDomain);
                    }
                    else {
                        log.error(data.Error);
                    }
                    self.initGrid(self.reportLookupLists.GridStructures.CallDetailsStructure);
                    ko.applyBindings(self, document.getElementById("ko-main-content"));
                    self.initCalendars();
                    $(".date-range-dropdown li.js-calendars").on("click", function () { return false; });
                    $("#contextLoader").hide();
                    $("#mainContext").show();
                }
            });
        };
        CallDetailsReport.prototype.initGrid = function (gridStructure) {
            var self = this;
            var columns = gridStructure.columns;
            self.mainTable = new KendoUtils.KendoUtils();
            var gridOptions = {
                dataSourceOptions: {
                    transport: {
                        read: {
                            url: "/Reports/GetCallDetailsData",
                            type: "POST",
                            data: function () {
                                self.filterInProgress(true);
                                var data = {};
                                data.fromdate = DateUtils.toIsoStringDate(self.filterCdrSummaryReportByStartDate());
                                data.todate = DateUtils.toIsoStringDate(self.filterCdrSummaryReportByEndDate());
                                if (self.filterCdrByDomain()) {
                                    data.domain = self.filterCdrByDomain();
                                }
                                if (self.filterCdrByFromPhoneNumber()) {
                                    data.fromNumber = self.filterCdrByFromPhoneNumber();
                                }
                                if (self.filterCdrByToPhoneNumber()) {
                                    data.toNumber = self.filterCdrByToPhoneNumber();
                                }
                                data.callTypes = self.multipleCallTypeSelector.value().join(",");
                                data.statuses = self.multipleStatusSelector.value().join(",");
                                return data;
                            },
                            dataType: "json"
                        }
                    },
                    aggregate: gridStructure.aggregate,
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                    serverAggregates: true,
                    schema: {
                        model: gridStructure.model,
                        data: function (response) { return response.Data; },
                        total: "Total",
                        aggregates: "Aggregates",
                        errors: "Errors"
                    },
                    sort: { field: "StartTime", dir: "desc" }
                },
                gridOptions: {
                    toolbar: kendo.template($("#cdrSummaryReport-toolbar-template").html()),
                    columns: columns,
                    autoBind: false,
                    height: "400px",
                    scrollable: true,
                    dataBound: function () {
                        self.filterInProgress(false);
                        $("button[data-action='applyFilter']").button("reset");
                    }
                },
                enableExport: {
                    entityName: "CallDetailsReport",
                    title: "Call Details Report",
                    enablePdf: false
                },
                allowBulkEdits: {
                    enabled: self.canExport()
                },
                autoHeight: {
                    totalOffset: 46 + 41 + 3
                },
                enableStickyHeader: true,
                gridId: "tblCdrSummaryReportKendo",
                showPagerOnTop: false,
                controller: self
            };
            self.mainTable.initGrid(gridOptions);
            $("#tblCdrSummaryReportKendo table").css("width", "");
            $("#tblCdrSummaryReportKendo").kendoTooltip({
                autoHide: false,
                showOn: "click",
                position: "left",
                filter: ".js-show-cdr-status",
                //width: 200,
                show: function (event) {
                    event.sender.popup.element.addClass("cdr-states-tool-tip");
                },
                contentLoad: function (e) {
                    var dataItem = KendoUtils.KendoUtils.getGridRowDataItem(e.sender.target);
                    var templateContent = $("#statesTooltipTemplate").html();
                    var template = kendo.template(templateContent);
                    return template(dataItem);
                }
            });
            self.multipleCallTypeSelector = $("#filterByCallTypeInput").kendoMultiSelect({
                autoBind: false,
                valuePrimitive: true,
                filter: "contains",
                autoClose: true,
                dataSource: {
                    data: ["Incoming", "Outgoing", "Internal", "Queues"]
                },
                dataBound: function () {
                    $(window).trigger("resize");
                },
                change: function (e) {
                    self.filterApplied(false);
                    var selectedTypes = self.multipleCallTypeSelector.value();
                    if (selectedTypes.indexOf("Queues") > -1) {
                        self.mainTable.getGridData().showColumn("AccountName");
                    }
                    else {
                        self.mainTable.getGridData().hideColumn("AccountName");
                    }
                    $(window).trigger("resize");
                }
            }).data("kendoMultiSelect");
            self.multipleCallTypeSelector.value(["Incoming", "Outgoing"]);
            self.multipleCallTypeSelector.trigger("change");
            self.multipleStatusSelector = $("#filterByStatusInput").kendoMultiSelect({
                autoBind: false,
                valuePrimitive: true,
                filter: "contains",
                placeholder: "All Statuses",
                autoClose: false,
                tagTemplate: $("#tagTemplate").html(),
                tagMode: "single",
                dataSource: {
                    data: ["Answered", "Not Answered", "Missed", "Mailbox", "Dropped"]
                },
                dataBound: function () {
                    $(window).trigger("resize");
                },
                change: function (e) {
                    self.filterApplied(false);
                    $(window).trigger("resize");
                }
            }).data("kendoMultiSelect");
            self.multipleStatusSelector.trigger("change");
            self.filterCdrSummaryReportByStartDate.subscribe(function () {
                self.filterApplied(false);
                self.selectCalandarRange();
            });
            self.filterCdrSummaryReportByEndDate.subscribe(function () {
                self.filterApplied(false);
                self.selectCalandarRange();
            });
            self.filterCdrByDomain.extend({ rateLimit: 200 }).subscribe(function () {
                self.filterApplied(false);
            });
            self.filterCdrByFromPhoneNumber.extend({ rateLimit: 200 }).subscribe(function () {
                self.filterApplied(false);
            });
            self.filterCdrByToPhoneNumber.extend({ rateLimit: 200 }).subscribe(function () {
                self.filterApplied(false);
            });
            $("#tblCdrSummaryReportKendo .grid-filter-form").on("keyup", function (e) {
                if (e.keyCode === 13) {
                    self.applyFilter();
                }
            });
        };
        CallDetailsReport.prototype.period = function (periodType) {
            var self = this;
            log.log(periodType);
            if (periodType === 0) { //today
                self.filterCdrSummaryReportByStartDate(DateUtils.today());
                self.filterCdrSummaryReportByEndDate(DateUtils.today());
                self.dateRangeText("Today");
            }
            else if (periodType === 1) {
                self.filterCdrSummaryReportByStartDate(DateUtils.addDays(DateUtils.today(), -1));
                self.filterCdrSummaryReportByEndDate(DateUtils.addDays(DateUtils.today(), -1));
                self.dateRangeText("Yesterday");
            }
            else if (periodType === 2) {
                self.filterCdrSummaryReportByStartDate(DateUtils.firstDayOfWeek(DateUtils.today()));
                self.filterCdrSummaryReportByEndDate(DateUtils.lastDayOfWeek(DateUtils.today()));
                self.dateRangeText("This Week");
            }
            else if (periodType === 3) {
                self.filterCdrSummaryReportByStartDate(DateUtils.firstDayOfWeek(DateUtils.addDays(DateUtils.today(), -7)));
                self.filterCdrSummaryReportByEndDate(DateUtils.lastDayOfWeek(DateUtils.addDays(DateUtils.today(), -7)));
                self.dateRangeText("Last Week");
            }
            else if (periodType === 4) {
                self.filterCdrSummaryReportByStartDate(DateUtils.firstDayOfMonth(DateUtils.today()));
                self.filterCdrSummaryReportByEndDate(DateUtils.lastDayOfMonth(DateUtils.today()));
                self.dateRangeText("This Month");
            }
            else if (periodType === 5) {
                self.filterCdrSummaryReportByStartDate(DateUtils.firstDayOfMonth(DateUtils.addMonths(DateUtils.today(), -1)));
                self.filterCdrSummaryReportByEndDate(DateUtils.lastDayOfMonth(DateUtils.addMonths(DateUtils.today(), -1)));
                self.dateRangeText("Last Month");
            }
            else if (periodType === 6) {
                self.filterCdrSummaryReportByStartDate(DateUtils.addDays(DateUtils.today(), -60));
                self.filterCdrSummaryReportByEndDate(DateUtils.addDays(DateUtils.today(), -1));
                self.dateRangeText("Last 60 days");
            }
            else if (periodType === 7) {
                self.filterCdrSummaryReportByStartDate(DateUtils.addDays(DateUtils.today(), -180));
                self.filterCdrSummaryReportByEndDate(DateUtils.addDays(DateUtils.today(), -1));
                self.dateRangeText("Last 180 days");
            }
        };
        CallDetailsReport.prototype.initCalendars = function () {
            var _this = this;
            var self = this;
            var startCalendar = $(".js-start-calendar").data("kendoCalendar");
            startCalendar.navigateToPast();
            var endCalendar = $(".js-end-calendar").data("kendoCalendar");
            startCalendar.bind("change", function (event) {
                var value = event.sender.value();
                console.log("start:", value); //value is the selected date in the calendar
                self.updateRangeText();
            });
            endCalendar.bind("change", function (event) {
                var value = event.sender.value();
                console.log("end:", value); //value is the selected date in the calendar
                self.updateRangeText();
            });
            startCalendar.bind("navigate", function (event) {
                var startValue = event.sender.current();
                var endValue = endCalendar.current();
                if (startValue.getMonth() === endValue.getMonth()) {
                    endCalendar.navigateToFuture();
                }
                self.selectCalandarRange();
            });
            endCalendar.bind("navigate", function (event) {
                var startValue = startCalendar.current();
                var endValue = event.sender.current();
                if (startValue.getMonth() === endValue.getMonth()) {
                    startCalendar.navigateToPast();
                }
                _this.selectCalandarRange();
            });
        };
        CallDetailsReport.prototype.updateRangeText = function () {
            var self = this;
            var today = DateUtils.today();
            var start = self.filterCdrSummaryReportByStartDate();
            var end = self.filterCdrSummaryReportByEndDate();
            //check if the same date
            if (start.getFullYear() === end.getFullYear() &&
                start.getMonth() === end.getMonth() &&
                start.getDate() === end.getDate()) {
                if (start.getFullYear() === today.getFullYear()) {
                    self.dateRangeText(kendo.toString(start, "m"));
                }
                else {
                    self.dateRangeText(kendo.toString(start, "d"));
                }
            }
            else {
                if (start.getFullYear() === today.getFullYear()) {
                    self.dateRangeText(kendo.toString(start, "m") + " - " + kendo.toString(end, "m"));
                }
                else {
                    self.dateRangeText(kendo.toString(start, "d") + " - " + kendo.toString(end, "d"));
                }
            }
        };
        CallDetailsReport.prototype.selectCalandarRange = function () {
            var self = this;
            if (self.selectRangeTimeout) {
                clearTimeout(self.selectRangeTimeout);
                log.log("clear timeout");
            }
            self.selectRangeTimeout = setTimeout(function () {
                log.log("select range");
                $("td a[data-value]").parent().removeClass("k-state-selected");
                var current = self.filterCdrSummaryReportByStartDate();
                var end = self.filterCdrSummaryReportByEndDate();
                var endFormatted = end.getFullYear() + "/" + end.getMonth() + "/" + end.getDate();
                var currentFormatted = current.getFullYear() + "/" + current.getMonth() + "/" + current.getDate();
                var index = 0;
                while (currentFormatted !== endFormatted && index < 1000) {
                    $('td a[data-value="' + currentFormatted + '"]').parent().addClass("k-state-selected");
                    current = DateUtils.addDays(current, 1);
                    currentFormatted = current.getFullYear() + "/" + current.getMonth() + "/" + current.getDate();
                    index++;
                }
                $('td a[data-value="' + currentFormatted + '"]').parent().addClass("k-state-selected");
            }, 200);
        };
        CallDetailsReport.prototype.applyFilter = function () {
            var self = this;
            if (!self.filterApplied() && !self.filterInProgress()) {
                $("button[data-action='applyFilter']").button("loading");
                self.mainTable.refresh();
                self.filterApplied(true);
            }
        };
        CallDetailsReport.prototype.clearFilter = function () {
            var self = this;
            self.filterCdrSummaryReportByStartDate(DateUtils.addDays(DateUtils.today(), -1));
            self.filterCdrSummaryReportByEndDate(DateUtils.addDays(DateUtils.today(), -1));
            self.filterCdrByDomain(self.defaultDomain);
            self.filterCdrByFromPhoneNumber("");
            self.filterCdrByToPhoneNumber("");
            self.multipleCallTypeSelector.value(["Incoming", "Outgoing"]);
            self.multipleCallTypeSelector.trigger("change");
            self.multipleStatusSelector.value([]);
            self.multipleStatusSelector.trigger("change");
        };
        CallDetailsReport.prototype.exportTo = function () {
            var self = this;
            if (self.canExport()) {
                self.mainTable.exportTo();
            }
        };
        return CallDetailsReport;
    }());
    setTimeout(function () {
        if (urls_1.urls.startsWith("/Reports/CallDetailsReport")) {
            log.log("Initialize CallDetailsReport list");
            $(function () {
                (new CallDetailsReport()).init();
            });
        }
    }, 0);
    return CallDetailsReport;
});
//# sourceMappingURL=CallDetailsReport.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/reports/callDetailsReport.js
// module id = 254
// module chunks = 2